<script setup lang="ts">
/**
 * Form field wrapper: <label>caption + control via slot</label>.
 * Use with AppInput as the default slot; matches legacy .form label structure
 * (caption stacked above the control, muted color, 0.65rem bottom gap).
 */
defineProps<{
  label: string;
  error?: string | null;
}>();
</script>

<template>
  <label class="form-field">
    <span class="form-field__caption">{{ label }}</span>
    <slot></slot>
    <span
      v-if="error"
      class="form-field__error"
    >{{ error }}</span>
  </label>
</template>

<style scoped>
.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
  color: var(--muted);
  margin-bottom: 0.65rem;
}

.form-field__caption {
  font-family: var(--font-ui);
  font-weight: var(--font-ui-light-weight);
}

.form-field__error {
  margin-top: 0.25rem;
  color: var(--danger);
  font-size: 0.75rem;
}
</style>
